import MediaItem from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPMedia/EDPMediaCarousel/MediaItem/MediaItem';

export default MediaItem;
